import { toast } from "react-toastify";
import { API_path } from "./apiPath";
import axiosInstance from "./axios";

const getMedicineData = async (branchId) => {
  let resMedicine = [];
  try {
    const response = await axiosInstance.get(API_path.getAllMedicine, {
      params: {
        branchId: branchId,
      },
    });
    const responseDate = response.data;
    if (responseDate && responseDate.status) {
      // toast.success(responseDate.paramObjectsMap.message);
      resMedicine = responseDate.paramObjectsMap.medicineVO;
    } else {
      toast.error(responseDate.paramObjectsMap.errorMessage);
    }
  } catch (error) {
    console.log(error);
  }
  return resMedicine;
};

export { getMedicineData };
